<template>
  <div class="home-section margin-top_24">
    <el-row type="flex" align="middle" class="section-title">
      <span class="text">权威发布</span>
      <el-radio-group v-model="activeIndex" size="small" class="content-tabs" @input="handleChangeTab">
        <el-radio v-for="item of tabs" :key="item.id" :label="item.id" border>{{ item.name }}</el-radio>
      </el-radio-group>
      <div class="nav-button" @click="toList">查看更多 >></div>
    </el-row>
    <div class="content">
      <div v-for="(item) of list" :key="item.id" class="item" @click="toDetail(item.id)">
        <img :src="item.infoImg" class="image">
        <div class="text-line">
          <span>{{ item.infoName }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '@/api/home/index'

export default {
  name: 'HomeSection4',

  data() {
    return {
      activeIndex: 2,
      tabs: [
        {
          id: 2,
          name: '人才标准'
        }
        // ,
        // {
        //   id: 1,
        //   name: '评价体系'
        // }
      ],
      list: []
    }
  },
  created() {
    this.handleGetList(this.activeIndex)
  },
  methods: {
    handleChangeTab(index) {
      this.handleGetList(index)
    },
    toList() {
      this.$router.push({
        path: '/authorityList',
        query: { type: this.activeIndex }
      })
    },
    toDetail(id) {
      const t = this.tabs.find(({ id }) => id === this.activeIndex)
      this.$router.push({
        path: '/authorityDetail',
        query: {
          id,
          type: t.id,
          rePath: `/authorityList?type=${t.id}`,
          reLabel: t.name
        }
      })
    },
    handleGetList(type) {
      const params = {
        page: 1,
        limit: 999,
        type
      }
      API.getAuthorityListByType(params).then(({ code, data }) => {
        if (code === 0) {
          let a, b, c, d, e, f, g
          const t = []
          data.records.forEach(item => {
            if (item.infoName.indexOf('天线工') !== -1) {
              a = item
            } else if (item.infoName.indexOf('机线员') !== -1) {
              b = item
            } else if (item.infoName.indexOf('全媒体运营师') !== -1) {
              c = item
            } else if (item.infoName.indexOf('网络与信息安全管理员') !== -1) {
              d = item
            } else if (item.infoName.indexOf('动画制作员') !== -1) {
              e = item
            } else if (item.infoName.indexOf('互联网营销师') !== -1) {
              f = item
            } else if (item.infoName.indexOf('无人机驾驶员') !== -1) {
              g = item
            } else {
              t.push(item)
            }
          })
          const r = [a, b, c, d, e, f, g].filter(Boolean)
          this.list = r.concat(t)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.home-section {
  box-sizing: border-box;
  padding: 24px;
  background: linear-gradient(180deg, #DFEDFF 0%, #FFFFFF 100%, #FFFFFF 100%);
  .section-title {
    .nav-button {
      margin-left: auto;
      font-size: 14px;
      color: #0861D5;
      cursor: pointer;
    }
  }
  .content-tabs {
    margin-left: 24px;
    ::v-deep .el-radio {
      width: auto;
      height: 32px;
      margin: 0;
      padding: 0 16px;
      border-radius: 4px;
      border: 1px solid #0861D5;
      font-size: 16px;
      color: #0861D5;
      .el-radio__input {
        display: none;
      }
      .el-radio__label {
        padding: 0;
        line-height: 32px;
      }
      &.is-checked {
        background: #0861D5;
        .el-radio__label {
          color: #FFFFFF;
        }
      }
      & + .el-radio {
        margin-left: 24px;
      }
    }
  }
  .content {
    width: auto;
    margin: 0 -12px;
    padding-top: 32px;
    .item {
      display: inline-block;
      width: 294px;
      height: 219px;
      margin: 0 12px;
      background: #FFFFFF;
      box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.05);
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;
      transition: all ease-in 0.15s;
      .image {
        width: 100%;
        height: 175px;
        vertical-align: middle;
      }
      .text-line {
        width: 100%;
        height: 45px;
        box-sizing: border-box;
        padding: 0 16px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 45px;
        text-align: center;
        font-size: 14px;
        color: #2F2F2F;
      }
      &:hover {
        box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.2);
      }
    }
  }
}
</style>
